module.exports = __webpack_public_path__ + "static/media/99gal04.7102b63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal04.jpg
// module id = 87
// module chunks = 0